'use client'

import {useEffect, useState} from 'react'
import type {RangeFilter} from '../types'
import RangeSlider from '@/src/shared/ui/inputs/slider'
import * as UI from './filters.styled'

interface FilterRangeProps {
  filter: RangeFilter
  onChange: (code: string, value: {from: number; to: number} | undefined) => void
  className?: string
}

export function FilterRange({filter, onChange, className}: FilterRangeProps) {
  const [sliderValue, setSliderValue] = useState<number[]>(() => [
    filter.selected_from ?? filter.from,
    filter.selected_to ?? filter.to,
  ])

  useEffect(() => {
    setSliderValue([filter.selected_from ?? filter.from, filter.selected_to ?? filter.to])
  }, [filter.selected_from, filter.selected_to, filter.from, filter.to])

  const handleChange = (values: number[] | undefined) => {
    if (!values || !Array.isArray(values)) return
    setSliderValue(values)
    onChange(filter.code, {from: values[0]!, to: values[1]!})
  }

  return (
    <UI.RangeFilter className={className}>
      <RangeSlider
        min={filter.from}
        max={filter.to}
        value={sliderValue}
        onChange={handleChange}
        step={100}
      />
    </UI.RangeFilter>
  )
}
